import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useState } from "react";
import { Stack, Text, useMantineTheme } from "@mantine/core";
import { Dropzone, MIME_TYPES, } from "@mantine/dropzone";
import { IconX } from "@tabler/icons";
import { BlobReader, ZipReader } from "@zip.js/zip.js";
import { isEmpty } from "lodash";
import { Upload as UploadIcon } from "@hl/base-components/lib/assets/icons.generated";
import { STATUS_COLOR } from "./theme/colors";
export const ZipDropzone = ({ handleEntries, validate, onDrop, maxSizeInMb = 500, minHeight = 128, multiple = false, onReject, setStagingFiles, ...rest }) => {
    const theme = useMantineTheme();
    const [rejections, setRejections] = useState([]);
    const handleZipFiles = async (zipFiles) => {
        for (const zipFile of zipFiles) {
            const zipReader = new ZipReader(new BlobReader(zipFile));
            handleEntries((await zipReader.getEntries()).filter((entry) => !entry.filename.match(/^__MACOSX\//)));
            await zipReader.close();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Dropzone, { onDrop: async (files) => {
                    var _a;
                    setStagingFiles === null || setStagingFiles === void 0 ? void 0 : setStagingFiles(files);
                    await handleZipFiles(files);
                    const invalidFiles = (_a = (await (validate === null || validate === void 0 ? void 0 : validate(files)))) !== null && _a !== void 0 ? _a : [];
                    if (isEmpty(invalidFiles)) {
                        setRejections([]);
                        onDrop === null || onDrop === void 0 ? void 0 : onDrop(files);
                    }
                    else {
                        onReject === null || onReject === void 0 ? void 0 : onReject(invalidFiles);
                        setRejections(invalidFiles);
                    }
                }, onReject: (files) => {
                    onReject === null || onReject === void 0 ? void 0 : onReject(files);
                    setRejections(files);
                }, accept: [
                    MIME_TYPES.zip,
                    // Deprecated mime-types, but still used by some browsers (e.g. Firefox in Windows)
                    "application/x-zip-compressed",
                    "application/zip-compressed",
                ], maxSize: maxSizeInMb * 1024 ** 2, multiple: multiple, ...rest, children: _jsxs(Stack, { align: "center", justify: "center", spacing: "sm", style: { minHeight, pointerEvents: "none" }, children: [_jsx(Dropzone.Reject, { children: _jsx(IconX, { size: 24, stroke: 1.5, color: theme.fn.variant({
                                    color: STATUS_COLOR.ERROR,
                                    variant: "filled",
                                }).background }) }), _jsx(Dropzone.Idle, { children: _jsx(UploadIcon, {}) }), _jsx(Text, { size: "sm", weight: 500, inline: true, children: "Upload .zip" })] }) }), !onReject && !!rejections.length && (_jsxs(Text, { mt: "sm", size: "sm", color: STATUS_COLOR.ERROR, children: ["Errors:", _jsx("ul", { children: rejections.map((rejection) => (_jsxs("li", { children: [rejection.file.name, _jsx("ul", { children: rejection.errors.map((error, i) => (_jsx("li", { children: error.message }, error.code + i))) })] }, rejection.file.name + rejection.file.lastModified))) })] }))] }));
};
